/**
 * Accounts & expenses (docs/SPEC.md §10).
 */
import { z } from 'zod';
import { idSchema, paisaSchema } from './common.js';
import { ACCOUNT_TYPES, PAYMENT_METHODS } from '../constants.js';
export const createAccountSchema = z.object({
    code: z.string().min(1).max(20),
    name: z.string().min(1).max(120),
    type: z.enum(ACCOUNT_TYPES),
    parentId: idSchema.nullable().optional(),
});
export const listLedgerEntriesQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    accountId: idSchema.optional(),
    partyId: idSchema.optional(),
    shopId: idSchema.optional(),
    journalId: idSchema.optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
});
export const trialBalanceQuerySchema = z.object({
    shopId: idSchema.optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
});
export const manualJournalLineSchema = z.object({
    accountId: idSchema,
    debitPaisa: paisaSchema.min(0).default(0),
    creditPaisa: paisaSchema.min(0).default(0),
    partyId: idSchema.optional(),
});
export const postManualJournalSchema = z.object({
    shopId: idSchema.optional(),
    businessDate: z.coerce.date().optional(),
    description: z.string().min(1).max(300),
    lines: z.array(manualJournalLineSchema).min(2),
});
/* -------------------------------------------------------------------------- */
/* Expenses                                                                    */
/* -------------------------------------------------------------------------- */
export const createExpenseSchema = z.object({
    shopId: idSchema.optional(),
    accountId: idSchema,
    payeeId: idSchema.optional(),
    amountPaisa: paisaSchema.min(1),
    taxPaisa: paisaSchema.min(0).default(0),
    method: z.enum(PAYMENT_METHODS).default('CASH'),
    description: z.string().max(500).optional(),
    attachmentFileIds: z.array(z.string()).default([]),
});
export const listExpensesQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    shopId: idSchema.optional(),
    status: z.string().optional(),
    accountId: idSchema.optional(),
});
//# sourceMappingURL=accounts.js.map